export function normaliseRadian (angle) {
  angle = angle < -Math.PI ? angle + 2 * Math.PI : angle
  angle = angle > Math.PI ? angle - 2 * Math.PI : angle
  return angle
}